<div class="main-content">
  <div class="header ion-padding">{{ "DISTANCE" | translate }}</div>
  <div class="content ion-padding">
    <div class="miles-lebel">
      {{ miles[distance].value }} {{ "MILES" | translate }}
    </div>
    <div class="range-wrapper">
      <div class="range-label">
        <div class="ion-text-center" *ngFor="let mile of miles">
          {{ mile.label }} {{ "MILES" | translate }}
        </div>
      </div>
      <ion-range
        data-cy="rangeInput"
        [(ngModel)]="distance"
        color="eprintprimary"
        ticks="true"
        snaps="true"
        min="0"
        max="5"
      ></ion-range>
    </div>

    <ion-button
      data-cy="distanceApplyBtn"
      [disabled]="this.miles[distance]?.value === distanceInMiles"
      color="eprintprimary"
      size="small"
      shape="block"
      (click)="apply()"
    >
      {{ "APPLY" | translate }}
    </ion-button>
  </div>
</div>
